import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  history: [],
  redirects: []
};

export const slice = createSlice({
  name: 'journeyRoutes',
  initialState,
  reducers: {
    setInitialState: (state) => {
      state.history = initialState.history;
      state.redirects = initialState.redirects;
    },
    pushHistory: (state, { payload }) => {
      const lastPath = state.history[state.history.length - 1];
      const history =
        // avoid pushing last path multiple time; This is caused usually by hotreload
        lastPath !== payload
          ? [...state.history, payload].filter(
              (p) => !state.redirects.includes(p)
            )
          : state.history;

      state.history = history;
    },
    replaceHistory: (state, { payload }) => {
      state.history[state.history.length - 1] = payload;
    },
    popHistory: (state, { payload }) => {
      const { history } = state;
      const pathIndex = history.indexOf(payload);

      return {
        ...state,
        history: [...history.slice(0, pathIndex + 1)] // + 1 to remove everything after, but not including poped path
      };
    },
    redirectPath: (state, { payload }) => {
      return {
        ...state,
        redirects: [...state.redirects, payload]
      };
    }
  }
});

export const {
  setInitialState,
  pushHistory,
  replaceHistory,
  popHistory,
  redirectPath
} = slice.actions;

export const selectSlice = (state) => state[slice.name];
export const selectHistory = (state) => selectSlice(state).history;
export const selectRedirects = (state) => selectSlice(state).redirects;
export const selectPreviousPath = (state) => {
  const history = selectHistory(state);
  const currentPath = history[history.length - 1];
  const hash = currentPath?.match(/#.*$/)?.[0];
  const noHashCurrentPath = currentPath?.replace(hash, '');
  const noHashCurrentPathIndex = history.indexOf(noHashCurrentPath);
  return history[noHashCurrentPathIndex - 1] || history[0];
};

export default slice.reducer;
